import { AbstractControl, ValidationErrors } from '@angular/forms';

export class DowodOsobistyValidator {
  private static readonly map: Record<string, number> = {
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    G: 16,
    H: 17,
    I: 18,
    J: 19,
    K: 20,
    L: 21,
    M: 22,
    N: 23,
    O: 24,
    P: 25,
    Q: 26,
    R: 27,
    S: 28,
    T: 29,
    U: 30,
    V: 31,
    W: 32,
    X: 33,
    Y: 34,
    Z: 35,
  };

  private static readonly weights = [7, 3, 1, 9, 7, 3, 1, 7, 3];

  static validNumberDokumentuTozsamosci(
    control: AbstractControl,
  ): ValidationErrors | null {
    const value: string | null | undefined = control.value;
    if (!value) {
      return null;
    }

    const normalized = value.toUpperCase().replace(/\s/g, '');

    // format 3 litery + 6 cyfr
    const pattern = /^[A-Z]{3}[0-9]{6}$/;
    if (!pattern.test(normalized)) {
      return { ['invalidNumerDokumentuTozsamosci']: true };
    }

    const valid =
      DowodOsobistyValidator.isValidNumberDokumentuTozsamosci(normalized);
    return valid ? null : { ['invalidNumerDokumentuTozsamosci']: true };
  }

  private static isValidNumberDokumentuTozsamosci(id: string): boolean {
    const chars = id.split('');
    let sum = 0;

    for (let i = 0; i < chars.length; i++) {
      const ch = chars[i];
      const n = this.map[ch as keyof typeof this.map] ?? parseInt(ch, 10);
      if (Number.isNaN(n)) {
        return false;
      }
      sum += n * this.weights[i];
    }

    return sum % 10 === 0;
  }
}
